import {
  MapPin,
  Share2,
  Brain,
  BookOpen,
  GraduationCap,
  Award,
  Bot,
  Gift,
  Headphones,
  LifeBuoy,
} from 'lucide-react';

/** Tools (साधने) dropdown — icons & colors used in desktop + mobile nav. */
export const toolsNavItems = [
  {
    to: '/trek-planner',
    labelKey: 'nav.trekPlanner',
    descKey: 'nav.trekPlannerDesc',
    Icon: MapPin,
    color: 'text-green-600',
    activeClass: 'bg-green-50 text-green-600',
  },
  {
    to: '/emergency',
    labelKey: 'nav.emergency',
    descKey: 'nav.emergencyDesc',
    Icon: LifeBuoy,
    color: 'text-red-700',
    activeClass: 'bg-red-50 text-red-800',
    matchPrefix: '/emergency',
  },
  {
    to: '/contributions',
    labelKey: 'nav.contributions',
    descKey: 'nav.contributionsDesc',
    Icon: Share2,
    color: 'text-purple-600',
    activeClass: 'bg-purple-50 text-purple-600',
  },
  {
    to: '/community',
    labelKey: 'nav.community',
    descKey: 'nav.communityDesc',
    Icon: Gift,
    color: 'text-rose-700',
    activeClass: 'bg-rose-50 text-rose-800',
    matchPrefix: '/community',
  },
  {
    to: '/fort-guide',
    labelKey: 'nav.fortGuide',
    descKey: 'nav.fortGuideDesc',
    Icon: Bot,
    color: 'text-indigo-700',
    activeClass: 'bg-indigo-50 text-indigo-800',
    matchPrefix: '/fort-guide',
  },
  {
    to: '/learn',
    labelKey: 'nav.learn',
    descKey: 'nav.learnDesc',
    Icon: GraduationCap,
    color: 'text-emerald-700',
    activeClass: 'bg-emerald-50 text-emerald-800',
  },
  {
    to: '/short-notes',
    labelKey: 'nav.shortNotes',
    descKey: 'nav.shortNotesDesc',
    Icon: BookOpen,
    color: 'text-amber-700',
    activeClass: 'bg-amber-50 text-amber-800',
  },
  {
    to: '/education/institutions',
    labelKey: 'nav.institutionPortal',
    descKey: 'nav.institutionPortalDesc',
    Icon: GraduationCap,
    color: 'text-sky-700',
    activeClass: 'bg-sky-50 text-sky-800',
  },
  {
    to: '/audiobooks',
    labelKey: 'nav.audiobooks',
    descKey: 'nav.audiobooksDesc',
    Icon: Headphones,
    color: 'text-orange-700',
    activeClass: 'bg-orange-50 text-orange-800',
  },
];

/** Hidden via featureVisibility.nav.tools.* when false. */
export const optionalToolsNavItems = [
  {
    featureKey: 'quiz',
    to: '/quiz',
    labelKey: 'nav.quiz',
    descKey: 'nav.quizDesc',
    Icon: Brain,
    color: 'text-indigo-500',
    activeClass: 'bg-indigo-50 text-indigo-600',
  },
  {
    featureKey: 'badges',
    to: '/badges',
    labelKey: 'nav.badges',
    descKey: 'nav.badgesDesc',
    Icon: Award,
    color: 'text-purple-500',
    activeClass: 'bg-purple-50 text-purple-600',
  },
];
